import React from "react";

export const Header = ({ data }) => {
    return (
        <header id="header">
            <div className="intro">
                <img
                    src="/img/intro-bg.jpg"
                    alt="KickerEck"
                    className="intro-bg"
                    loading="lazy"
                    data-testid="home-hero-image"
                />
                <div className="overlay">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2 intro-text">
<h1>
                                    {data?.title || "Das KickerEck"}
                                    <span></span>
                                </h1>
                                <div className="intro-cta-wrap">
                                    <a href="#KickCalendar" className="btn btn-custom btn-lg page-scroll">
                                        Nächste Turniere
                                    </a>
                                    <a href="#about" className="btn-outline-hero btn-lg page-scroll">
                                        Mehr erfahren
                                    </a>
                                </div>
                                <div className="scroll-indicator">
                                    <span className="scroll-arrow"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};
